import theme from '../themes/default'
// import arrowImage from '../../images/select_dropdown_arrow.png'

export default {
  card: {
    border: '1px solid rgb(219,219,219)',
    maxWidth: '350px',
    margin: '86px auto 10px',
    display: 'flex',
    flexDirection: 'column',
    height: '320px',
    padding: '10px 0 20px',
    borderRadius: '1px',
    'z-index': '1',
    position: 'relative',
    'background-color': 'white',
  },
  backdrop: {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100vw',
    height: '100vh',
    'background-color': 'rgba(250,250,250,1)',
    'z-index': 0,
  },
  logoDiv: {
    'background-repeat': 'no-repeat',
    // 'background-position': '-98px 0',
    height: '80px',
    width: '230px',
    margin: '22px auto 12px',
  },
  inputDiv: {
    margin: '0 40px 6px',
  },
  input: {
    'background-color': 'rgba(250,250,250,1)',
    border: '1px solid rgba(219,219,219,1)',
    width: '100%',
    '-webkit-appearance': 'none',
    flex: '1 0 auto',
    margin: '0',
    'margin-left': '-8px',
    padding: '9px 8px 7px 8px',
    'font-size': '16px',
    'border-radius': '3px',
    color: 'rgba(38,38,38,1)',
    height: '20px',
    'line-height': '18px',
    '&::placeholder': {
      'font-size': '14px',
    },
  },
  loginBtn: {
    color: 'rgb(255,255,255)',
    width: '100%',
    border: '1px solid transparent',
    cursor: 'pointer',
    position: 'relative',
    'font-size': '14px',
    'box-sizing': 'content-box',
    'font-weight': '600',
    'line-height': '18px',
    'border-radius': '4px',
    'background-color': 'rgba(0,149,246,1)',
    '-webkit-appearance': 'none',
    padding: '9px 8px 7px 8px',
    'margin-left': '-8px',
    '&:active,&:focus': {
      outline: 'rgb(0,9,204) auto 1px',
    },
  },
  loginBtnDiv: {
    'margin-top': '8px',
    'margin-bottom': '10px',
  },
  merchantAccountDiv: {
    'margin-top': '24px',
  },
  disabledInput: {
    'pointer-events': 'none',
    opacity: '0.6',
  },
  disabled: {
    'background-color': 'rgba(0,149,246,0.3)',
    border: '1px solid transparent',
    'pointer-events': 'none',
  },
  loading: {
    display: 'inline-block',
    width: '14px',
    height: '14px',
    border: '3px solid rgba(255,255,255,.3)',
    'border-radius': '50%',
    'border-top-color': '#fff',
    animation: 'spin 1s ease-in-out infinite',
    'box-sizing': 'border-box',
    'pointer-events': 'none',
  },
  '@keyframes spin': {
    to: { '-webkit-transform': 'rotate(360deg)' },
  },
}



// WEBPACK FOOTER //
// ./src/assets/styles/components/WaiterLogin.js